import {RouterModule, Routes} from '@angular/router';
import {PaymentComponent} from 'r2-payment';
import {ClientDetailsComponent} from 'r2-client-details-module';
import {BeneficiaryComponent} from 'r2-beneficiary-module';
import {AdvisorComponent} from 'r2-advisor-module';
import {FinalizeComponent} from 'r2-finalize';
import {DeclarationComponent} from 'declaration';
import {GeneralDeactivateGuardService} from './general-deactivate-guard.service';
import { DirectAccessActivateGuardService } from './direct-access-activate-guard.service';

const ROUTES: Routes = [
  {path: 'payment', component: PaymentComponent, canDeactivate: [GeneralDeactivateGuardService],
  canActivate: [DirectAccessActivateGuardService]},
  {path: 'planOwner', component: ClientDetailsComponent, canDeactivate: [GeneralDeactivateGuardService],
   canActivate: [DirectAccessActivateGuardService]},
  {path: 'peopleOnYourPlan', component: BeneficiaryComponent, canDeactivate: [GeneralDeactivateGuardService],
  canActivate: [DirectAccessActivateGuardService]},
  {path: 'adviser', component: AdvisorComponent, canDeactivate: [GeneralDeactivateGuardService],
  canActivate: [DirectAccessActivateGuardService]},
  {path: 'declaration', component: DeclarationComponent, canDeactivate: [GeneralDeactivateGuardService],
  canActivate: [DirectAccessActivateGuardService]},
  {path: 'finalize', component: FinalizeComponent, canDeactivate: [GeneralDeactivateGuardService],
  canActivate: [DirectAccessActivateGuardService]},
  {path: '', redirectTo: '/payment', pathMatch: 'full'}

];
export const ROUTING_MODULE_IMPORTS = [
  RouterModule.forRoot(ROUTES, {onSameUrlNavigation: 'ignore'})
];
export const ROUTING_MODULE_EXPORTS = [
  RouterModule
];

export const ROUTING_MODULE_PROVIDERS = [
  GeneralDeactivateGuardService,
  DirectAccessActivateGuardService
];

